module.exports = __webpack_public_path__ + "static/media/plan-mas-400gb.894c9f31.svg";